import { FC, forwardRef, HTMLAttributes } from 'react'
import styled from 'styled-components'
import AnswerRadioButton from './AnswerRadioButton'

interface IFProps extends HTMLAttributes<HTMLInputElement> {
  userAnswer?: number
}

const AnswerRadioButtonGroup: FC<IFProps> = forwardRef<
  HTMLInputElement,
  IFProps
>(({ id, userAnswer, ...restProps }, ref) => {
  return (
    <StyledWrapper>
      {new Array(5).fill(0).map((_, index) => {
        return (
          <AnswerRadioButton
            ref={ref}
            key={`${id}-${index}`}
            id={`${id}-${index}`}
            value={index + 1}
            label={index + 1}
            defaultChecked={userAnswer === index + 1}
            {...restProps}
          />
        )
      })}
    </StyledWrapper>
  )
})

export default AnswerRadioButtonGroup

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`
